define('views/shared/unsubscribe/unsubscribe',["backbone",
        "text!views/shared/unsubscribe/unsubscribe.html",
        "views/_base/baseview",
        "models/shared/settings/settingvalue_collection",
        "models/shared/settings/settingvalue"
], function (Backbone, Template, BaseView, SettingValues, SettingValue) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        tagName: "section",
        isRender: true,
        needsAuth: false,
        initialize: function (options) {
            options || (options = {});
            this.userGUID = options.UG;
            this.event = options.Event;
            if (this.userGUID != undefined && this.userGUID != "NonMember")
            {
                var url = pf.url + "/Unsubscribe/SettingAttributes/" + this.userGUID;
                var settingsArray = new SettingValues();
                if (this.event)
                {
                    settingsArray.add(new SettingValue({ SID: enums.userAttributeTypes.WebsiteEventNotificationByEmail, SV: "0" }));
                }
                else
                {
                    settingsArray.add(new SettingValue({ SID: enums.userAttributeTypes.WebsiteNotificationByEmail, SV: "0" }));
                }

                var that = this;
                $.ajax({
                    type: 'POST',
                    async: false,
                    url: url,
                    contentType: "application/json",
                    data: JSON.stringify(settingsArray),
                    success: function (response) {
                        if (response != null && response.length > 0) {
                            pf.session.attributes.UserSettingAttributes = new SettingValues(response, { parse: true });
                            //that.$("#member").removeClass("hidden");
                        }
                        else {
                            pfdialog.error({ context: this, Body: "Failed to save settings. Please try again.", Title: "Error" });
                        }
                    },
                    error: function (response) {
                        pfdialog.error({ context: this, Body: "Failed to save settings. Please try again.", Title: "Error" });
                    }
                });
            }
            BaseView.prototype.initialize(this);
        },
        events: {
            "click #Unsubscribe": "unsubscribe"
        },
        render: function () {
            this.$el.html(Template);
            if (this.userGUID == "NonMember")
            {
                this.$("#member").addClass("hidden");
                this.$("#nonmember").removeClass("hidden");

            }
                
            return this;
        },
        unsubscribe: function () {
            var that = this;
            $.ajax({
                type: 'POST',
                url: pf.url + '/Unsubscribe/UnsubscribeNonMember',
                async: false,
                contentType: "application/json",
                data: JSON.stringify({ E: that.$("#EmailAddress").val() }),
                success: function (response) {
                    that.$("#nonmember").addClass("hidden");
                    that.$("#nonmemberConfirm").removeClass("hidden");
                },
                error: function (response) {
                    alert("err");
                }
            });


        },
        close: function () { }
    });
});

